export const Roles = [
  {id: "SUPER_ADMIN", name: "ویژه"},
  {id: "USERS_ADMIN", name: "کاربر"},
  {id: "MARKETING_ADMIN", name: "مارکت"},
];

export const ChatRoles = [
  { id: 'PREGNANCY_SPECIALIST', name: 'PREGNANCY_SPECIALIST' },
  { id: 'CANCER_SPECIALIST', name: 'CANCER_SPECIALIST' },
  { id: 'MAMA_SPECIALIST', name: 'MAMA_SPECIALIST' },
  { id: 'EXPERT', name: 'EXPERT' },
  { id: 'NORMAL', name: 'NORMAL' },
  { id: 'CRM', name: 'CRM' },
  { id: 'SUPER_ADMIN', name: 'SUPER_ADMIN' },
];

export const Markets = [
  { id: 'GOOGLE_PLAY', name: 'GOOGLE_PLAY' },
  { id: 'CAFE_BAZAAR', name: 'CAFE_BAZAAR' },
  { id: 'IOS_TESTFLIGHT', name: 'IOS_TESTFLIGHT' },
  { id: 'MYKET', name: 'MYKET' },
  { id: 'IOS_APP_STORE', name: 'IOS_APP_STORE' },
  { id: 'GOOGLE_PLAY_SHERO', name: 'GOOGLE_PLAY_SHERO' },
  { id: 'APP_STORE_SHERO', name: 'APP_STORE_SHERO' },
  { id: 'PWA', name: 'PWA' },
  { id: 'PWA_SHERO', name: 'PWA_SHERO' },
];

export const MarketsFilter = [
  { name: 'GOOGLE_PLAY', value: 'GOOGLE_PLAY' },
  { name: 'CAFE_BAZAAR', value: 'CAFE_BAZAAR' },
  { name: 'IOS_TESTFLIGHT', value: 'IOS_TESTFLIGHT' },
  { name: 'MYKET', value: 'MYKET' },
  { name: 'IOS_APP_STORE', value: 'IOS_APP_STORE' },
  { name: 'GOOGLE_PLAY_SHERO', value: 'GOOGLE_PLAY_SHERO' },
  { name: 'APP_STORE_SHERO', value: 'APP_STORE_SHERO' },
  { name: 'PWA', value: 'PWA' },
  { name: 'PWA_SHERO', value: 'PWA_SHERO' },
];

export const UserConditions = [
  { id: 0, name: 'ADMIN' },
  { id: 1, name: 'HIDDEN' },
  { id: 2, name: 'MUTE' },
  { id: 3, name: 'DISABLE' },
];

export const ConversationType = [
  { id: 'PUBLIC', name: 'PUBLIC' },
  { id: 'PRIVATE', name: 'PRIVATE' },
];

export const Products = [
  { id: 'KARAFS', name: 'KARAFS' },
  { id: 'LUNA', name: 'LUNA' },
  { id: 'BENTO', name: 'BENTO' },
  { id: 'DENJ', name: 'DENJ' },
  { id: 'GYM', name: 'GYM' },
];

export const ConversationStatusFilter = [
  {name: "باز (OPEN)", value: 0},
  {name: "بسته (CLOSE)", value: 1},
];